const state = {
  start_weekday: 0
}
const mutations = {
  SET_START_WEEEKDAY(state, payload) {
    state.start_weekday = payload
  }
}
const actions = {}

export default {
  namespaced: true,
  state, mutations, actions
}
